module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-haven-fluted-hamilton-0.8670fbc6.jpg";